<div class="panel-body">
  <table class="table table-striped table-condensed">
    <thead>
      <tr>
        <th>Talhão</th>
        <th ng-if="recomendacaoSemeadura.tempAdubacao.gleba || recomendacaoSemeadura.data.adubacao.length">Área</th>
        <th>Adubo</th>
        <th colspan="2">Dose</th>
      </tr>
    </thead>
    <tfoot>
      <tr>
        <td>
          <div class="form-group">
            <select
              ng-model="recomendacaoSemeadura.tempAdubacao.gleba"
              class="form-control"
              ng-options="gleba as recomendacaoSemeadura.aduboGlebaDescricao(gleba) for gleba in recomendacaoSemeadura.data.glebas"
            >
              <option value="">Todos os talhões</option>
            </select>
          </div>
        </td>
        <td ng-if="recomendacaoSemeadura.tempAdubacao.gleba">
          <div class="form-group">
            <div class="input-group">
              <input type="number" ng-model="recomendacaoSemeadura.tempAdubacao.area" auto-step class="form-control" min="0" placeholder="Área">
              <span class="input-group-addon">ha</span>
            </div>
          </div>
        </td>
        <td>
          <div class="form-group">
            <ui-select ng-model="recomendacaoSemeadura.tempAdubacao.adubo" theme="bootstrap">
              <ui-select-match allow-clear="true" placeholder="Adubo">{{$select.selected.descricao | characters:30}}</ui-select-match>
              <ui-select-choices repeat="adubo in recomendacaoSemeadura.adubos | filter: $select.search | limitTo: 50">
                <div ng-bind-html="adubo.descricao | highlight: $select.search"></div>
              </ui-select-choices>
            </ui-select>
          </div>
        </td>
        <td>
          <div class="form-group">
            <div class="input-group">
              <input type="number" ng-model="recomendacaoSemeadura.tempAdubacao.dose" class="form-control" auto-step min="0" placeholder="Dose">
              <span class="input-group-addon">{{((recomendacaoSemeadura.tempAdubacao.adubo.unidade || {}).abreviatura.trim() || 'kg') | lowercase }}/ha</span>
            </div>
          </div>
        </td>
        <td>
          <button type="button" class="btn btn-link" ng-click="recomendacaoSemeadura.saveAdubacao()" ng-disabled="recomendacaoSemeadura.addAduboDisabled()">Salvar</button>
          <button type="button" class="btn btn-link text-warning" ng-click="recomendacaoSemeadura.cancelEditAdubo()" ng-show="recomendacaoSemeadura.editAduboId !== false">Cancelar</button>
        </td>
      </tr>
    </tfoot>
    <tbody>
      <tr ng-repeat="adubo in recomendacaoSemeadura.data.adubacao track by $index" ng-style="{'background-color': adubo._edit ? '#fcf8e3' : ''}">
        <td>{{adubo.gleba.descricao}}</td>
        <td>{{adubo.area | number: 2}} ha</td>
        <td>{{adubo.adubo.descricao}}</td>
        <td>{{adubo.dose | number}} {{adubo.adubo.unidade.abreviatura.trim().trim() | lowercase }}/ha</td>
        <td class="text-right">
          <div ng-show="!adubo._edit">
            <button type="button" class="btn btn-link text-info" ng-click="recomendacaoSemeadura.editAdubo($index)" ng-show="recomendacaoSemeadura.data.status == 'rascunho'"><i class="fa fa-edit"></i></button>
            <button type="button" class="btn btn-link text-danger" ng-click="recomendacaoSemeadura.deleteAdubo($index)"><i class="fa fa-trash"></i></button>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
